import {
  POST_CURRENT_XM_INSTRUMENT,
  POST_CURRENT_XM_INSTRUMENT_SUCCESS,
  POST_CURRENT_XM_INSTRUMENT_FAILURE,
  GET_CURRENT_XM_INSTRUMENT_FAILURE,
  GET_CURRENT_XM_INSTRUMENT_SUCCESS,
} from '../actions/currentXMAutopayInstrument';

const INITIAL_STATE = {
  loading: false,
  error: null,
  data: null,
};

export default function otPaymentinstrument(state = INITIAL_STATE, action) {
  switch (action.type) {
    case POST_CURRENT_XM_INSTRUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_CURRENT_XM_INSTRUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ccType: action.payload.ccType,
          ccLastFour: action.payload.ccLastFour,
        },
      };
    case POST_CURRENT_XM_INSTRUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Store Current XM Payment Autopay Instrument
    case GET_CURRENT_XM_INSTRUMENT_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
      };
    case GET_CURRENT_XM_INSTRUMENT_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
